<div fxLayout="column" fxLayoutAlign="center center" style="height: 100%;" class="fade-in">
    <div class="wrapper">
        <div class="login mat-elevation-z1">
            <bp-card-loading-spinner-overlay [isLoading]="isLoading"></bp-card-loading-spinner-overlay>
        </div>
    </div>
</div>